// extracted by mini-css-extract-plugin
export default {"title":"Typography_title__u-XBE","subtitle":"Typography_subtitle__9Ca4g","text":"Typography_text__S--3n"};